import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { RootState } from 'src/config/rootStore';
import * as authSelectors from 'src/modules/auth/selectors/authenticationSelectors';
import { TimelyResponseBanner } from 'src/modules/dashboard/components/TimelyResponseBanner';
import { VerifyEmailAddressBanner } from 'src/modules/dashboard/components/VerifyEmailAddressBanner';
import { getUserInformation, isUserDataFetched } from 'src/modules/user/selectors/userSelectors';

import { useLocalizedVersion } from '../hooks/useLocalizedVersion';
import { Footer } from './Footer';
import { Header } from './Header';
import * as S from './styles';

type Props = RouteComponentProps & ReturnType<typeof mapStateToProps>;

const AppLayoutContainer: React.FC<Props> = props => {
    const flags = useFlags();
    const [localizedVersion] = useLocalizedVersion();

    const shouldShowVerifyEmailAddressBanner =
        props.location.pathname.includes('/dashboard') &&
        props.user.newEmailAddressNotConfirmed != '' &&
        props.user.newEmailAddressNotConfirmed != null;
    const shouldShowTimelyResponseBanner =
        props.location.pathname.includes('/dashboard') &&
        flags?.showTimelyResponseBanner &&
        !localizedVersion;
    const shouldShowHeader = !props.isAuthenticating && props.userDataFetched;
    const shouldShowFooter = !props.isAuthenticated && !props.isAuthenticating;

    return (
        <>
            {shouldShowVerifyEmailAddressBanner ? (
                <VerifyEmailAddressBanner />
            ) : shouldShowTimelyResponseBanner ? (
                <TimelyResponseBanner />
            ) : null}
            {shouldShowHeader ? <Header /> : null}
            <S.Content data-testid="appContent">{props.children}</S.Content>
            {shouldShowFooter ? <Footer /> : null}
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    isAuthenticated: authSelectors.isAuthenticated(state),
    isAuthenticating: authSelectors.isAuthenticating(state),
    userDataFetched: isUserDataFetched(state),
    user: getUserInformation(state),
});

export const AppLayout = connect(mapStateToProps)(withRouter(AppLayoutContainer));
